export default "__VITE_PUBLIC_ASSET__78f9280c__"